import React from 'react';
import { useTuneStore } from '../state/storeTunePrayer';
import { usePostMeta } from './usePostMeta';
import { InputSchemaValid } from '../validations/locationIsValid';
import { useConditional } from '../state/storeConditional ';

export const usePostTune = () => {
	const [ Imsak, SetImsak ] = React.useState< InputSchemaValid >();
	const [ Fajr, SetFajr ] = React.useState< InputSchemaValid >();
	const [ Sunrise, SetSunrise ] = React.useState< InputSchemaValid >();
	const [ Dhuhr, SetDhuhr ] = React.useState< InputSchemaValid >();
	const [ Asr, SetAsr ] = React.useState< InputSchemaValid >();
	const [ Sunset, SetSunset ] = React.useState< InputSchemaValid >();
	const [ Maghrib, SetMaghrib ] = React.useState< InputSchemaValid >();
	const [ Isha, SetIsha ] = React.useState< InputSchemaValid >();
	const [ Midnight, SetMidnight ] = React.useState< InputSchemaValid >();

	const updateImsak = useTuneStore( ( state ) => state.updateImsak );
	const updateFajr = useTuneStore( ( state ) => state.updateFajr );
	const updateSunrise = useTuneStore( ( state ) => state.updateSunrise );
	const updateDhuhr = useTuneStore( ( state ) => state.updateDhuhr );
	const updateAsr = useTuneStore( ( state ) => state.updateAsr );
	const updateMaghrib = useTuneStore( ( state ) => state.updateMaghrib );
	const updateSunset = useTuneStore( ( state ) => state.updateSunset );
	const updateIsha = useTuneStore( ( state ) => state.updateIsha );
	const updateMidnight = useTuneStore( ( state ) => state.updateMidnight );
	const {isReadyGenerator,isReadyToPost } = useConditional();

	const { appendDataPost } = usePostMeta();
	React.useEffect( () => {
		if ( Fajr?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Fajr );
			SetFajr( { meta: '', value: '' } );
		}
		if ( Imsak?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Imsak );
			SetImsak( { meta: '', value: '' } );
		}
		if ( Sunrise?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Sunrise );
			SetSunrise( { meta: '', value: '' } );
		}
		if ( Dhuhr?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Dhuhr );
			SetDhuhr( { meta: '', value: '' } );
		}
		if ( Asr?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Asr );
			SetAsr( { meta: '', value: '' } );
		}
		if ( Sunset?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Sunset );
			SetSunset( { meta: '', value: '' } );
		}
		if ( Maghrib?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Maghrib );
			SetMaghrib( { meta: '', value: '' } );
		}
		if ( Isha?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Isha );
			SetIsha( { meta: '', value: '' } );
		}
		if ( Midnight?.value && isReadyGenerator && isReadyToPost ) {
			appendDataPost( Midnight );
			SetMidnight( { meta: '', value: '' } );
		}
	}, [ isReadyGenerator, isReadyToPost ] );
	const getInputTune = ( data: InputSchemaValid ) => {
		if ( data.meta === 'Imsak' ) {
			SetImsak( data );
			updateImsak( data.value as string );
		}
		if ( data.meta === 'Fajr' ) {
			SetFajr( data );
			updateFajr( data.value as string );
		}
		if ( data.meta === 'Sunrise' ) {
			SetSunrise( data );
			updateSunrise( data.value as string );
		}
		if ( data.meta === 'Dhuhr' ) {
			SetDhuhr( data );
			updateDhuhr( data.value as string );
		}
		if ( data.meta === 'Asr' ) {
			SetAsr( data );
			updateAsr( data.value as string );
		}
		if ( data.meta === 'Sunset' ) {
			SetSunset( data );
			updateSunset( data.value as string );
		}
		if ( data.meta === 'Maghrib' ) {
			SetMaghrib( data );
			updateMaghrib( data.value as string );
		}
		if ( data.meta === 'Isha' ) {
			SetIsha( data );
			updateIsha( data.value as string );
		}
		if ( data.meta === 'Midnight' ) {
			SetMidnight( data );
			updateMidnight( data.value as string );
		}
	};

	return { getInputTune };
};
